
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const TemplesPage = lazy(() => import('../pages/temples/page'));
const TempleDetailPage = lazy(() => import('../pages/temple-detail/page'));
const DonatePage = lazy(() => import('../pages/donate/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const UserDashboard = lazy(() => import('../pages/user/dashboard/page'));
const TempleDashboard = lazy(() => import('../pages/temple/dashboard/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AstrologersPage = lazy(() => import('../pages/astrologers/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/temples',
    element: <TemplesPage />
  },
  {
    path: '/temple/:id',
    element: <TempleDetailPage />
  },
  {
    path: '/donate',
    element: <DonatePage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/user/dashboard',
    element: <UserDashboard />
  },
  {
    path: '/temple/dashboard',
    element: <TempleDashboard />
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/faq',
    element: <FAQPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/astrologers',
    element: <AstrologersPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
